import { Button, ButtonProps } from '@mui/material';
import { MouseEventHandler } from 'react';

export const ShowMoreButton = ({
  showShowMoreButton,
  onClick,
  text,
  ...rest
}: {
  showShowMoreButton: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  text: string;
} & ButtonProps) => {
  return showShowMoreButton ? (
    <Button size="small" onClick={onClick} {...rest}>
      {text}
    </Button>
  ) : null;
};
